import React from 'react';

interface Props {
  code: string;
  locale: string;
}

const ActionPlanStatusBadge: React.FC<Props> = ({ code, locale }) => (
  <div className="badge-base action-plan-status">
    <div className="badge-text">
      <span>{locale || code}</span>
    </div>
  </div>
);

export default React.memo(ActionPlanStatusBadge);
